module.exports = __webpack_public_path__ + "img/logo-branco.01c6857f.png";